<script>
import { layoutComputed } from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

/**
 * Main Layout Router
 * Chuyển đổi giữa Vertical (Admin) và Horizontal layout
 * dựa trên cấu hình Vuex store
 */
export default {
  components: {
    Vertical,
    Horizontal,
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.classList.remove("auth-body-bg");
    // Áp dụng màu nền quản trị nhất quán
    document.body.style.backgroundColor = "var(--color-admin-bg, #f4f6f8)";
  },
  methods: {},
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl');
  },
};
</script>

<template>
  <div class="main-layout-root">
    <!-- Vertical Layout (Admin Dashboard) -->
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical>

    <!-- Horizontal Layout -->
    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>
  </div>
</template>

<style>
/* =========================================
   MAIN LAYOUT - Chỉ set font & màu nền body
   KHÔNG override CSS của SideBar template cũ
   ========================================= */
body {
  background-color: var(--color-admin-bg, #f4f6f8) !important;
  font-family: var(--font-body, "Inter"), -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

/* Wrapper gốc - không override flexbox để tương thích SideBar */
.main-layout-root {
  width: 100%;
  min-height: 100vh;
}

/* Fix header avatar spacing */
.header-item img {
  margin-top: 13px;
}
</style>
